import React from 'react';

interface DownloadButtonProps {
  onDownload: () => void;
  onReset: () => void;
}

export function DownloadButton({ onDownload, onReset }: DownloadButtonProps) {
  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={onDownload}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded text-xs font-medium bg-green-600 hover:bg-green-500 text-white transition-colors"
      >
        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
        </svg>
        Download MP4
      </button>
      <button
        type="button"
        onClick={onReset}
        className="px-2.5 py-1.5 rounded text-xs text-zinc-400 hover:text-zinc-200 hover:bg-zinc-700 transition-colors"
      >
        New Render
      </button>
    </div>
  );
}
